import { ele } from "cables-shared-client";
import web from "../../index.js";
import api from "../../api.js";

export default class PageTests
{
    constructor(_targetElement)
    {
        let url = new URL(window.location.href);
        let limit = url.searchParams.get("l") || 20;
        let offset = url.searchParams.get("o") || 0;

        ele.clickables(ele.byId("lists"), ".button", (e, dataSet) =>
        {
            if (dataSet && dataSet.id) window.location.href = "/patchlist/" + dataSet.id;
        });

        const resultContainer = ele.byId("runcontainer");
        const apiUrl = web.tabs.addPagination("test/runs", limit, offset);
        api.get(apiUrl, (result) =>
        {
            if (result.data && Array.isArray(result.data))
            {
                let html = "<table>";
                result.data.forEach((testRun) =>
                {
                    testRun.showProjectLink = true;
                    html += web.getHandleBarHtml("test_runrow", testRun);
                });
                resultContainer.innerHTML = html + "</table>";
            }
            web.tabs.initPagination(resultContainer, result.pagination, limit, offset);
        }, () => {});
    }
}
